// CSS
import '../scss/index.scss';

// Polyfills
import './lib/polyfills';

// Vendors
import $ from 'jquery';
import 'fancybox/dist/js/jquery.fancybox.pack';
import 'jquery.maskedinput/src/jquery.maskedinput';
import './lib/wl-share';

// Framework
import carousels from './framework/carousel';
import code from './framework/code';
import dropdowns from './framework/dropdown';
import modals from './framework/modal';
import notices from './framework/notice';
import toggles from './framework/toggle';
import tooltips from './framework/tooltip';
import utilities from './framework/utilities';

// Site modules
import './site/accordion';
import './site/back-to-top';
import './site/events-form';
import './site/footer';
import './site/google-maps';
import './site/header';
import './site/mobile-nav';
import './site/modal-subscribe';
import './site/secondary-nav';
import './site/page-builder';
import './site/search-autosuggest';
import './site/side-nav';
import './site/sticky-header';
import './site/recommended-reading';

// Applications are loaded separately per-page via assets.php / webpack entries

// Apply input masks
$('.mask-input-phone').mask('(999) 999-9999');
$('.mask-input-date').mask('99/99/9999');

// Init Fancybox
$('.fancybox').fancybox({
  helpers: {
    overlay: {
      locked: false // Prevent page from jumping back to top
    }
  }
});

// Init single carousel
const carouselSingle = carousels('[data-carousel="single"]', {
  autoplay: false,
  dots: true,
  infinite: true,
  speed: 500,
  nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="icon-arrow-long-right-white"></i></button>`,
  prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="icon-arrow-long-left-white"></i></button>`,
  dots: false,
  adaptiveHeight: false,
  responsive: [
    {
      breakpoint: 576,
      settings: {
        arrows: true,
        autoplay: false,
        speed: 500
      }
    }
  ]
});

// Init multiple carousel
const carouselMultiple = carousels('[data-carousel="multiple"]', {
  autoplay: true,
  dots: false,
  infinite: true,
  autoplaySpeed: 2000,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});

// Init modals
modals('[data-modal]');

// Init toggles
toggles('[data-toggle-target]');

// Init notices
notices('[data-notice-dismissible]');

// Init code
code('[data-code]');

// Init tooltips
tooltips('[data-tooltip]');

// Init dropdowns
dropdowns('[data-dropdown]');
